import { Injectable } from "@angular/core";
import { FocusFieldStrategy } from "../directives/navigation-section.directive";
import { BaseNavigationStrategyService } from "./base-navigation-strategy.service";
import { NavigationService } from "./navigation.service";

@Injectable()
export class LeftRightChangeSectionUpDownChangeFieldNavigationStrategy extends BaseNavigationStrategyService {
    handleKeyPress(event: KeyboardEvent): void {
        if (NavigationService.LEFT_KEY.includes(event.keyCode)) {
            this.moveToPreviousSection(FocusFieldStrategy.Last);
        } else if (NavigationService.RIGHT_KEY.includes(event.keyCode)) {
            this.moveToNextSection(FocusFieldStrategy.First);
        } else if (NavigationService.UP_KEY.includes(event.keyCode)) {
            this.moveToPreviousField(event);
        } else if (NavigationService.DOWN_KEY.includes(event.keyCode)) {
            this.moveToNextField(event);
        }
    }
}
